import { apiPatch, apiPost } from 'shared/services/apiRequest';

const updateDeviceSettingService = async (category, deviceIds, data, testDevices) =>
    (await apiPatch(`/${category}/update-setting`, { deviceIds, ...data, testDevices }))?.data;

export const updateSwitchSettingService = (...args) =>
    updateDeviceSettingService("switches", ...args);

export const updateBlowerSettingService = (...args) =>
    updateDeviceSettingService("blowers", ...args);

export const updateDevicesValveService = async (data, testDevices) =>
    (await apiPost("/blowers/open-valve/bulk", data, testDevices))?.data;
